import React, { FC } from 'react';
import { useTheme } from '../../../hooks/useTheme';

import styles from './Divider.module.css';

const Divider: FC = () => {
  const { dividerPrimaryNone } = useTheme();

  return (
    <hr className={styles.hr} style={dividerPrimaryNone} role="presentation" />
  );
};

export default Divider;
